export function readCookie(name: string) {
  for (const cookie of document.cookie.split(';')) {
    const [key, value] = cookie.split('=')

    if (key.trim() === name) {
      return value
    }
  }
}
